import React from 'react';
import { Search, Plus } from 'lucide-react';
import type { MantenedorTab } from '../types';

interface FilterProps {
    searchQuery: string;
    setSearchQuery: (query: string) => void;
    activeTab: MantenedorTab;
    onCreateClick: () => void;
}

export const MantenedoresFilter: React.FC<FilterProps> = ({ 
    searchQuery, 
    setSearchQuery, 
    activeTab, 
    onCreateClick 
}) => {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-4 sm:px-7 py-4 border-b border-gray-100 bg-gray-50/50 shrink-0">
            <div className="flex items-center w-full sm:w-[320px] gap-2 px-3 py-2 transition-colors border rounded-lg bg-white border-gray-300 focus-within:border-[#4f6df5] focus-within:ring-1 focus-within:ring-[#4f6df5]/20 shadow-sm">
                <Search size={16} className="text-gray-400 shrink-0" />
                <input 
                    type="text" 
                    placeholder={`Buscar en tipo de ${activeTab === 'propiedad' ? 'propiedad' : 'alojamiento'}...`}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full text-[13px] bg-transparent border-none outline-none text-gray-900 placeholder:text-gray-400"
                />
            </div>
            
            <button 
                onClick={onCreateClick}
                className="flex items-center justify-center gap-2 px-4 py-2 text-[13px] font-semibold text-white transition-colors rounded-lg bg-[#4f6df5] hover:bg-[#3f58c7] shadow-sm whitespace-nowrap"
            >
                <Plus size={16} />
                Nuevo tipo de {activeTab}
            </button>
        </div>
    );
};